import {
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from 'firebase/storage';
import { storage } from './firebase';

/**
 * Upload an image for a post
 * @param userId The user's ID
 * @param file The image file to upload
 * @returns The download URL of the uploaded image
 */
export async function uploadPostImage(
  userId: string,
  file: File
): Promise<string> {
  // Generate a unique filename
  const timestamp = Date.now();
  const filename = `${timestamp}_${file.name}`;
  const storageRef = ref(storage, `posts/${userId}/${filename}`);

  // Upload the file
  const snapshot = await uploadBytes(storageRef, file);
  
  // Get and return the download URL
  const downloadUrl = await getDownloadURL(snapshot.ref);
  return downloadUrl;
}

/**
 * Delete an image from storage
 * @param imageUrl The full URL of the image to delete
 */
export async function deletePostImage(imageUrl: string): Promise<void> {
  try {
    // Extract the path from the URL
    const storageRef = ref(storage, imageUrl);
    await deleteObject(storageRef);
  } catch (error) {
    // If the file doesn't exist, that's okay
    console.warn('Could not delete image:', error);
  }
}

/**
 * Upload a user avatar
 * @param userId The user's ID
 * @param file The avatar file to upload
 * @returns The download URL of the uploaded avatar
 */
export async function uploadAvatar(
  userId: string,
  file: File
): Promise<string> {
  const storageRef = ref(storage, `avatars/${userId}/avatar`);
  const snapshot = await uploadBytes(storageRef, file);
  const downloadUrl = await getDownloadURL(snapshot.ref);
  return downloadUrl;
}
